module.exports = __webpack_public_path__ + "static/media/md-chatbubbles.c391d90d.svg";